import React from 'react';
import { formatCurrency } from '../givingHelpers';

const OPTIONS = [
  {
    value: 'cancel_now',
    label: 'Cancel all recurring gifts now',
    hint: 'Donors stop being charged immediately.',
  },
  {
    value: 'cancel_at_period_end',
    label: 'Cancel at the end of the current period',
    hint: 'Donors keep the period they already paid for, then billing stops.',
  },
];

const GivingRecurringCancelOptions = ({ count, amountCents, value, onChange }) => {
  if (!count) return null;

  return (
    <div className="gconfirm-recurring">
      <p className="gconfirm-recurring-summary">
        This campaign has <strong>{count}</strong> active recurring {count === 1 ? 'gift' : 'gifts'}
        {amountCents ? <> totaling <strong>{formatCurrency(amountCents)}</strong> per period</> : null}.
        {' '}Choose what happens to {count === 1 ? 'it' : 'them'}:
      </p>
      {OPTIONS.map((opt) => (
        <label key={opt.value} className="gconfirm-recurring-option">
          <input
            type="radio"
            name="recurring_donation_handling"
            value={opt.value}
            checked={value === opt.value}
            onChange={() => onChange(opt.value)}
          />
          <span>
            <span className="gconfirm-recurring-option-label">{opt.label}</span>
            <span className="gconfirm-recurring-option-hint">{opt.hint}</span>
          </span>
        </label>
      ))}
    </div>
  );
};

export default GivingRecurringCancelOptions;
